export var Constants = {
    ATTRIBUTES: {
        EDITOR_ID: 'data-editor-id',
        LOCATION_ID: 'data-velt-location-id',
    },
};
